"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
const common_1 = require("../../../@inax/common");
const ng2_toastr_1 = require("ng2-toastr/ng2-toastr");
let InaxLoggerService = class InaxLoggerService {
    constructor(_http, _configuration, _profileService, _toastr) {
        this._http = _http;
        this._configuration = _configuration;
        this._profileService = _profileService;
        this._toastr = _toastr;
    }
    /***********************************************************************
     *          WEB API
     * ********************************************************************/
    logServerInfo(message) {
        let accessUrl = this._configuration.buildRestUrl("Logger", "Info");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, message, { headers }).map(res => res.json());
    }
    logServerDebug(message) {
        let accessUrl = this._configuration.buildRestUrl("Logger", "Debug");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, message, { headers }).map(res => res.json());
    }
    logServerError(message) {
        let accessUrl = this._configuration.buildRestUrl("Logger", "Error");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, message, { headers }).map(res => res.json());
    }
    logServerFatal(message) {
        let accessUrl = this._configuration.buildRestUrl("Logger", "Fatal");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, message, { headers }).map(res => res.json());
    }
    logServerWarn(message) {
        let accessUrl = this._configuration.buildRestUrl("Logger", "Warn");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, message, { headers }).map(res => res.json());
    }
    logInfo(message, showToast = false, data = null, source = "") {
        this.log(message, data, source, showToast, 'info');
    }
    logWarning(message, showToast = false, data = null, source = "") {
        this.log(message, data, source, showToast, 'warning');
    }
    logSuccess(message, showToast = false, data = null, source = "") {
        this.log(message, data, source, showToast, 'success');
    }
    logError(message, showToast = false, data = null, source = "") {
        this.log(message, data, source, showToast, 'error');
    }
    log(message, data, source, showToast, toastType) {
        source = source ? '[' + source + '] ' : '';
        if (toastType === 'error')
            console.error(message, data);
        else
            console.log(message, data);
        if (showToast) {
            if (toastType === 'error') {
                this._toastr.error(message);
            }
            else if (toastType === 'warning') {
                this._toastr.warning(message);
            }
            else if (toastType === 'success') {
                this._toastr.success(message);
            }
            else {
                this._toastr.info(message);
            }
        }
    }
};
InaxLoggerService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        common_1.InaxConfiguration,
        common_1.ProfileService,
        ng2_toastr_1.ToastsManager])
], InaxLoggerService);
exports.InaxLoggerService = InaxLoggerService;
